export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf01-mobile-de.21b790d2.png";